 import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";

import { Router } from "@angular/router";
import swal from "sweetalert2";
import { error } from "console";
import { T } from "@angular/core/src/render3";

@Component({
  selector: "app-master-area",
  templateUrl: "./purchase-order.component.html",
  styleUrls: ["./purchase-order.component.scss"],
})


export class PurchaseOrderComponent implements OnInit {
  myForm: FormGroup;



  constructor(
    private router: Router
  ) {

    ///.Checklis
    const idUser = new FormControl("");
    const center = new FormControl("");
    const place = new FormControl("");
    this.myForm = new FormGroup({
      idUser: idUser,
      center: center,
      place: place,
    });
  }

  ngOnInit() {}


}



// WEBPACK FOOTER //
// ./src/app/master/PurchaseOrder/purchase-order.component.ts